import Vue from 'vue'
import '../assets/css/font/iconfont.css'//以前权限的图标
import '../assets/css/foots/iconfont.css'//新加权限的图标
import '../assets/foot/iconfont.css'
import '../assets/css/page/iconfont.css'
import http from '../service/http.js'
import common from '../common/common.js'
import { exportMethod } from '../common/upData.js'
import moment from 'moment'
import vTabs from "../byComponents/vTabs.vue";
import * as printSocketApi from '../websocket/printWebsocket.js'
import '../byComponents/byComponents.js'
import IndexDBCache from "../index.js";
Vue.prototype.$dbCache = new IndexDBCache((msg) => console.log(msg));
Vue.prototype.$printSocketApi = printSocketApi
Vue.component("vTabs", vTabs)
Vue.prototype.$common = common
Vue.prototype.$exportMethod = exportMethod
Vue.prototype.$http = http
Vue.prototype.$moment = moment
